import { CoreButton, CoreModal } from '@komodo-design-system/komodo-components-react';
import React from 'react';
import './ConfirmationAlertBox.scss';

interface ConfirmationAlertBoxProps {
  message: string;
  header?: string;
  isModalOpen: boolean;
  handleAction: (action: string, inputProps?: object) => void;
  cancelText?: string;
  okText?: string;
  inputProps?: object;
  isDisabled?: boolean;
}

function ConfirmationAlertBox({ message, header, isModalOpen, handleAction, cancelText, okText, inputProps, isDisabled }: ConfirmationAlertBoxProps) {
  return (
    <div data-testid="confirmation-alert-box" className='confirmation-alert-box'>
      <CoreModal
        className='confirmation-alert-box-modal'
        data-testid="confirmation-alert-box-modal"
        isopen={isModalOpen}
        bgclose={false}
        closeicon={false}
        header={header || ''}
      >
        <div className='confirmation-alert-box-content'>
          <p style={{ fontSize: '16px', fontWeight: 500 }} >{message}</p>
        </div>
        <div className='confirmation-alert-box-buttons'>
          <CoreButton
            label={okText || 'YES'}
            variant="primary"
            onClick={() => handleAction('YES', inputProps)}
            disabled={isDisabled}
          />
          <CoreButton
            label={cancelText || 'NO'}
            variant="outline"
            onClick={() => handleAction('NO', inputProps)}
          />
        </div>
      </CoreModal>
    </div>
  );
}

export default ConfirmationAlertBox;

